module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loading":"Loading"},"pt-BR":{"loading":"Carregando"}}')
  delete Component.options._Ctor
}
